import React from "react";
import Banner from "../component/Home/Banner";
import TopDestinations from "../component/Home/TopDestinations";
import PromotionalTours from "../component/Home/PromotionalTours";
import SearchForm from "../component/Home/SearchForm";
import Seo from "component/Common/seo";

const Home = () => {
    return (
        <>
            <Seo
                title="Je Voyage Ici | Réservation de Vols et Hôtels en Algérie"
                description="Réservez vos billets d'avion et hôtels en Algérie avec paiement sécurisé CIB et DAHABIA. Comparez les meilleures offres sur une plateforme 100% algérienne."
                canonical="/"
                image="/images/preview-bg.png"
            />
            <Banner />
            <SearchForm />
            <TopDestinations />
            <PromotionalTours />
        </>
    );
};

export default Home;